import Card from './Card';
import "./CardGrid.css";

export default function CardGrid({ pictures, onLikeToggle, onEdit, onDelete }) {
    const items = Array.isArray(pictures) ? pictures : [];
    if (items.length === 0) {
        return (
        <div className="empty-state">
            <p>No pictures to show</p>
        </div>
        );
    }

    return (
        <div className="picture-grid">
            {items.map((pic) => (
                <Card
                    key={pic.publicId}
                    picture={pic}
                    onLikeToggle={onLikeToggle}
                    onEdit={onEdit}
                    onDelete={onDelete}
                />
            ))}
        </div>
    );
}
